import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { finalize, switchMap } from 'rxjs';
import { PartnerService } from '../../../services/partner.service';
import CustomValidators from '../../../shared/custom-validators';
import { SessionStorageService } from '../../../services/session-storage.service';

@Component({
  selector: 'app-components-partner-company-information',
  templateUrl: './company-information.component.html'
})
export class CompanyInformationComponent implements OnInit {
  partner: Boo.Objects.Partner;
  partnerManager: Boo.Objects.PartnerUser;

  formGroup: FormGroup;
  billingContactNameControl: FormControl<string>;
  billingContactEmailControl: FormControl<string>;

  isLoading = true;

  constructor(
    private sessionStorageService: SessionStorageService,
    private partnerService: PartnerService) {
  }

  ngOnInit(): void {
    this.sessionStorageService.getPartner()
      .pipe(
        finalize(() => this.isLoading = false)
      )
      .subscribe({
        next: (partner) => {
          this.partner = partner;
          this.setupForm();
        },
        error: (err) => toastr.error(err)
      });
  }

  save(): void {
    if (!this.isValid()) {
      return;
    }

    this.partner.BillingContactName = this.billingContactNameControl.value?.trim() ?? '';
    this.partner.BillingContactEmailAddress = this.billingContactEmailControl.value?.trim() ?? '';

    this.partnerService.update(this.partner, false, null)
      .pipe(
        finalize(() => this.isLoading = false),
        switchMap(() => this.partnerService.get(this.partner.PartnerId))
      )
      .subscribe({
        next: (partner) => {
          this.partner = partner;
          this.sessionStorageService.setPartner(partner);
          this.setupForm();
          toastr.success('Company Information updated successfully');
        },
        error: (err) => toastr.error(err)
      });
  }

  private setupForm(): void {
    this.billingContactNameControl = new FormControl(this.partner.BillingContactName ?? '', [Validators.required]);
    this.billingContactEmailControl = new FormControl(this.partner.BillingContactEmailAddress ?? '', [Validators.required, CustomValidators.email]);

    this.formGroup = new FormGroup({
      billingContactName: this.billingContactNameControl,
      billingContactEmail: this.billingContactEmailControl
    });
  }

  private isValid(): boolean {
    Object.keys(this.formGroup.controls).forEach(key => {
      this.formGroup.controls[key].markAsDirty();
      this.formGroup.controls[key].updateValueAndValidity();
    });

    return this.formGroup.valid;
  }
}